import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import pick from 'lodash/pick';

import './TravelingPreferences.css';
import { detachUserProvider } from 'modules/user/api';
import { hideBackdrop, showBackdrop } from 'modules/backdrop/actions';
import { noop } from 'functions/noop';
import { REMATCH_URL_SEARCH_PARAM } from 'utils/constants/urlSearchParameters';
import {
  PopupTitle, PopupContent, PopupButton, PopupSubtitle,
} from 'new-ui/Components/Popup';
import { useTranslation } from 'utils/modifiedTranslation';
import Form from 'new-ui/Components/Form';
import { ROUTE_PATH, ROUTE_NAME } from 'utils/constants/router';

const PROVIDER_DETACH_COMMENT = 'user requested to see the full list after sponsored sites are over 100m';
const BACKDROP_REASON = 'traveling_preferences_popup';
const REDIRECT_URL = `${ROUTE_PATH[ROUTE_NAME.RESULTS]}?${REMATCH_URL_SEARCH_PARAM}=1`;

const TravelingPreferences = ({ closePopup }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const {
    appConfiguration: { providerSpecific },
    profile: { data: user },
  } = useSelector((state) => pick(state, ['appConfiguration', 'profile']));
  const [disabled, setDisabled] = useState(true);
  const [form, setForm] = useState(null);
  const distance = user.personal?.travel_limit || 100;
  useEffect(() => {
    setForm({
      inputs: {
        TravelingPreferences: {
          type: 'radio',
          options: [
            {
              value: 'YES',
              title: t('popup.traveling_preferences.yes_option'),
            },
            {
              value: 'NO',
              title: t('popup.traveling_preferences.no_option', {
                PARTNER_NAME: providerSpecific?.name,
              }),
            },
          ],
        },
      },
      data: {
        TravelingPreferences: '',
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (data) => {
    setDisabled(data.TravelingPreferences === '');
  };

  const save = () => {
    if (form.data.TravelingPreferences === 'YES') {
      closePopup();
      dispatch(showBackdrop({ reason: BACKDROP_REASON }));
      detachUserProvider({ auditComment: PROVIDER_DETACH_COMMENT })
        .then(() => {
          window.location = REDIRECT_URL;
        })
        .catch(noop)
        .finally(() => {
          dispatch(hideBackdrop({ reason: BACKDROP_REASON }));
        });
    }
    if (form.data.TravelingPreferences === 'NO') {
      closePopup();
    }
  };
  return (
    <div className="traveling-preferences">
      <PopupTitle title={t('popup.traveling_preferences.title')} />
      <PopupSubtitle subtitle={t('popup.traveling_preferences.subtitle', {
        PARTNER_NAME: providerSpecific?.name,
        INDICATION_NAME: user.personal.condition,
        DISTANCE: distance === 'none' ? 100 : distance,
      })}
      />
      <PopupContent>
        {form && <Form onChange={onChange} inputs={form.inputs} data={form.data} />}
      </PopupContent>
      <PopupButton disabled={disabled} title={t('popup.traveling_preferences.btn')} action={save} />
    </div>
  );
};

TravelingPreferences.propTypes = {
  closePopup: PropTypes.func.isRequired,
};

export default TravelingPreferences;
